import { useIsAuthenticated } from '@azure/msal-react';
import { Grid, Link, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { ContactForm } from '../contactForm/contactForm';

export const HelpAndService = () => {
  const { t } = useTranslation();
  const routerLink = {
    color: '#FFF',
    textDecoration: 'none',
  };
  const authenticated = useIsAuthenticated();
  const [showContactForm, setShowContactForm] = useState(false);

  const onClose = () => {
    setShowContactForm(false);
  };

  return (
    <>
      {authenticated && (
        <ContactForm open={showContactForm} onClose={onClose} />
      )}
      <Grid
        container
        direction="column"
        height="100%"
        justifyContent="space-between"
        spacing="10"
      >
        <Grid item>
          <Typography variant="h4" color="inherit" fontFamily="JHFontBold">
            {t('HelpAndService')}
          </Typography>
        </Grid>
        {authenticated && (
          <Grid item>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              variant="h5"
              color="#FFF"
              underline="hover"
              onClick={() => setShowContactForm(true)}
              style={{ cursor: 'pointer' }}
            >
              {t('Contact')}
            </Link>
          </Grid>
        )}
        <Grid item>
          <Link
            variant="h5"
            color="#FFF"
            underline="hover"
            href="https://www.jungheinrich.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t('CorporateWebsite')}
          </Link>
        </Grid>
        <Grid item>
          <RouterLink
            to="/termsofuse"
            style={routerLink}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            <Typography variant="h5" color="inherit">
              {t('TermsOfUse')}
            </Typography>
          </RouterLink>
        </Grid>
      </Grid>
    </>
  );
};
